
const messageFromErrors = errors => {
    if (!errors) return null;
    if (!Array.isArray(errors)) return `Couldn't parse error message. 'errors' is not an array`;
    const firstError = errors[0];
    if (!firstError) return `Couldn't parse error message. No error found at start of array`;
    const message = firstError.path ? `${firstError.path}: ${firstError.message}` : firstError.message;
    return errors.length > 1 ? `${message} + ${errors.length - 1} more` : message;
}

export class GraphQlError extends Error {
    constructor(errors, request) {
        super(messageFromErrors(errors));
        this.name = 'GraphQlError';
        this.errors = errors;
        this.request = request;
    }
}
